import React from 'react';

import { observer } from 'src/utils/mobx-react';

import { columns } from './config';

import { DataTable } from 'src/domains/common/components/data-table/data-table';

import { ExpandedRow } from 'src/domains/sportsbook/trading/view/payment-search/PaymentSearchResults/ExpandedRow';
import { RequestDataType, SuccessResponseType } from 'src_server/types/paymentSearch/paymentsSearchTypes';
import { Button } from 'src/domains/common/components/button/button';
import { money } from 'src/utils/format';

interface PaymentSearchResultsPropType {
    results: SuccessResponseType | undefined;
    requestQuery: RequestDataType | undefined;
    getResults: (data: RequestDataType) => void;
    clearResults: () => void;
}

export const PaymentSearchResults = observer('PaymentSearch', (props: PaymentSearchResultsPropType) => {
    const { results, requestQuery, getResults, clearResults } = props;

    return (
        <div className='flex flex-col gap-6 w-full max-h-[calc(100vh-72px)]'>
            <div className='flex flex-col gap-3'>
                <Button
                    onClick={() => clearResults()}
                    variant='outline'
                    className='w-fit'
                    icon='caret-left'
                >
                    Back
                </Button>
                <div className='flex justify-between'>
                    <span className='text-base font-semibold'>Payment Search Results</span>
                    <div className='flex gap-2 text-sm items-end'>
                        <span>Total Value:</span>
                        <span className='font-medium'>{money(results?.aggregations?.totalValue, 'GBP')}</span>
                    </div>
                </div>
            </div>

            <DataTable
                columns={columns}
                data={results?.results ?? []}
                totalCount={results?.aggregations?.total}
                getRowCanExpand={() => true}
                renderSubComponent={({ row }) => <ExpandedRow row={row} />}
                onPaginationChange={(pagination) => {
                    if (requestQuery === undefined) return;
                    getResults({ ...requestQuery, page: pagination.pageIndex + 1, perPage: pagination.pageSize });
                }}
            />
        </div>
    );
});
